<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row">
                    <div class="col-md-12">
                        <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
                            <i class="fa fa-chevron-circle-left"></i> Nazaj
                        </a>
                    </div>
                </div>

                <div class="row" v-if="Object.keys(nodeData).length > 0">

                    <div class="col-md-12">

                        <div class="alert alert-warning"><i class="fa fa-exclamation-triangle pr-2"></i> Zajem EVIP</div>
                        <h2 class="preventLongStringOutbreak">
                            <i :class="$globalFunctions.getFileTypeIcon(nodeData.content.mimeType)"></i> {{nodeData.properties["cm:title"]}}
                        </h2>
                        <h6>
                            <b>Originalno ime: {{nodeData.properties["rma:origionalName"] ? nodeData.properties["rma:origionalName"] : '/'}}</b>
                        </h6>
                        <p class="mb-3">
                            <small><i class="fa fa-calendar text-black-50"></i> {{moment(nodeData.modifiedAt).local().format("DD. MM. YYYY HH:mm:ss")}} <span
                                        class="text-black-50">|</span> <i class="fa fa-user text-black-50"></i> {{nodeData.modifiedByUser.displayName}}</small>
                        </p>
                    </div>

                </div>

                <div class="row">

                    <loading :active.sync="isLoading"
                             :can-cancel="false"
                             :is-full-page="false"></loading>


                    <div class="col-md-8 mb-5">

                        <div class="row" v-if="Object.keys(nodeData).length > 0">
                            <div class="col-md-12 form-condensed">



                                <div class="p-4 bg-light">

                                    <b-button id="uploadTestPropertiesButton2"
                                              @click="loadSampleNodeData('SU')" class="btn-sm mb-3">Predizpolni vsa polja z SU testnimi podatki

                                    </b-button>


                                    <h4>Podatki o dokumentu</h4>



                                    <div class="form-group">
                                        <label for="title">Naslov</label>
                                        <input type="text" class="form-control" id="title"
                                               aria-describedby="title"
                                               v-model="nodeData.properties['cm:title']"
                                               name="title"
                                               :class="{'is-invalid': errors.title}"
                                        >
                                        <div class="invalid-feedback"
                                             v-if="errors.title">
                                            Polje Naslov je obvezno.
                                        </div>
                                    </div>



                                    <div class="form-group">
                                        <label for="description">Kratek opis vsebine</label>
                                        <textarea class="form-control" id="description"
                                                  aria-describedby="description"
                                                  v-model="nodeData.properties['cm:description']"
                                                  name="description"
                                                  :class="{'is-invalid': errors.description}"
                                        ></textarea>
                                        <div class="invalid-feedback"
                                             v-if="errors.description">
                                            Polje Opis je obvezno.
                                        </div>
                                    </div>


                                    <div class="form-group">
                                        <label for="author">Avtor</label>
                                        <input type="text" class="form-control" id="author"
                                               aria-describedby="author"
                                               v-model="nodeData.properties['cm:author']"
                                               name="author"
                                               :class="{'is-invalid': errors.author}"
                                        >
                                        <div class="invalid-feedback"
                                             v-if="errors.author">
                                            Polje Avtor je obvezno.
                                        </div>
                                    </div>





                                    <div>

                                        <div class="form-group">
                                            <label for="mimetype">Vrsta dokumenta</label>
                                            <input type="text" class="form-control" id="mimetype"
                                                   aria-describedby="mimetype"
                                                   :placeholder="nodeData.content.mimeType"
                                                   disabled
                                            />
                                        </div>

                                        <div class="form-group">
                                            <label for="size">Velikost datoteke</label>
                                            <input type="text" class="form-control" id="size"
                                                   aria-describedby="size"
                                                   :placeholder="nodeData.content.sizeInBytes | prettyBytes"
                                                   disabled
                                            />
                                        </div>


                                        <div class="form-group">
                                            <label for="createdAt"> Datum in ura zajema enote gradiva</label>
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    id="createdAt"
                                                    aria-describedby="createdAt"
                                                    :placeholder="moment(nodeData.createdAt).local().format('DD. MM. YYYY HH:mm:ss')"
                                                    disabled

                                            />
                                        </div>

                                    </div>
                                </div>

                                <hr/>


                                <div v-for="(aspect, index) in eHrambaAspectsDictionary" :key="index" v-if="(!nodeData.properties['EH:komponenta_povezave_na_dokumente'] || (nodeData.properties['EH:komponenta_povezave_na_dokumente'] && aspect.name === 'EH:komponenta')) && aspect.title !== 'E-podpis' && aspect.name !== 'EH:verzioniranje' && aspect.name !== 'EH:verzija_type' && aspect.name !== 'EH:verzija' && aspect.name !== 'EH:porocilo' && aspect.name !== 'EH:pretvorjeno_gradivo' && aspect.name !== 'EH:pretvorba_za_dolgorocno_hrambo' && aspect.name !== 'EH:pretvorjeno_gradivo_assoc_aspect'">

                                    <div v-if="aspects.indexOf(aspect.name) > -1">
                                    <div class="p-4 bg-light">

                                        <h4>{{aspect.title}}</h4>

                                        <div v-for="property in aspect.properties"
                                             :class="property.dataType === 'd:boolean' ? 'form-check' : 'form-group'">

                                            <!--                                            {{property}}-->

                                            <input v-if="property.dataType === 'd:boolean'" type="checkbox"
                                                   class="form-check-input"
                                                   :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="disabledFieldsEditMode.includes(property.name)"
                                            >

                                            <label :for="property.name">{{property.title}}<span
                                                    v-if="markedFieldsAddMode.includes(property.name)">**</span><small
                                                    class="text-black-50">(typ:
                                                {{property.dataType}}, id: <i class="fa fa-info" :title="property.name"></i>)</small></label>

                                            <div>


                                                <input v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name !== 'EH:klasifikacijska_oznaka_razreda'  && property.name !== 'EH:komponenta_povezave_na_dokumente'"
                                                       type="text" class="form-control" :id="property.name"
                                                       v-model="nodeData.properties[property.name]"
                                                       :disabled="disabledFieldsEditMode.includes(property.name)"

                                                >

                                                <!-- klasifikacijska oznaka razreda-->
                                                <input v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name === 'EH:klasifikacijska_oznaka_razreda' && property.name !== 'EH:komponenta_povezave_na_dokumente'"
                                                       type="text" class="form-control" :id="property.name"
                                                       v-model="nodeData.properties[property.name]"
                                                       :disabled="disabledFieldsEditMode.includes(property.name)"
                                                />

                                                <vue-tags-input v-if="property.dataType === 'd:text' && property.name === 'EH:komponenta_povezave_na_dokumente'"
                                                                :id="aspect.properties['EH:komponenta_povezave_na_dokumente'].name"
                                                                v-model="componentTag"
                                                                :tags="componentTags"
                                                                placeholder="vpiši ID gradiva in pritisni Enter"
                                                                style="max-width: initial"
                                                                @tags-changed="newTags => {componentTags = newTags; onComponentTagsChanged(newTags)}"
                                                />


                                                <input v-if="property.dataType === 'd:long' || property.dataType === 'd:int'"
                                                       type="number"
                                                       class="form-control" :id="property.name"
                                                       v-model="nodeData.properties[property.name]"
                                                       :disabled="disabledFieldsEditMode.includes(property.name)"

                                                >


                                                <div v-if="property.dataType == 'd:datetime'">
                                                    <div v-if="disabledFieldsEditMode.includes(property.name)">
                                                        <input
                                                                type="text"
                                                                class="form-control"
                                                                :id="property.name"
                                                                :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).local().format('DD. MM. YYYY HH:mm:ss') : ''"
                                                                disabled
                                                        />
                                                    </div>
                                                    <div v-else>
                                                        <VueCtkDateTimePicker
                                                                :id="property.name"
                                                                format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                                formatted="DD.MM.YYYY, HH:mm"
                                                                v-model="nodeData.properties[property.name]"
                                                                locale="sl"
                                                                :noLabel="true"
                                                                :button-now-translation="$t('text.globals.now')"
                                                        />
                                                    </div>
                                                </div>


                                                <div v-if="property.dataType == 'd:date'">
                                                    <div v-if="disabledFieldsEditMode.includes(property.name)">
                                                        <input
                                                                type="text"
                                                                class="form-control"
                                                                :id="property.name"
                                                                :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).local().format('DD. MM. YYYY') : ''"
                                                                disabled

                                                        />
                                                    </div>
                                                    <div v-else>
                                                        <VueCtkDateTimePicker
                                                                :id="property.name"
                                                                format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                                formatted="DD.MM.YYYY"
                                                                :onlyDate="true"
                                                                :noLabel="true"
                                                                v-model="nodeData.properties[property.name]"
                                                                locale="sl"
                                                                :button-now-translation="$t('text.globals.now')"
                                                        />
                                                    </div>
                                                </div>

                                            </div><!-- end of else -->

                                        </div>

                                    </div>

                                    <hr/>


                                    </div>


                                </div>

                                <div v-if="aspect.name === 'EH:e_podpis'"
                                     v-for="(aspect, index) in eHrambaAspectsDictionary" :key="'eHrambaAspectsDictionary_' + index">

                                    <div class="p-4 bg-light">
                                        <h4>{{aspect.title}}</h4>


                                        <div
                                            :class="aspect.properties['EH:stevilo_podpisov'] && aspect.properties['EH:stevilo_podpisov'].dataType === 'd:boolean' ? 'form-check' : 'form-group'"
                                            :key="'property_EH_stevilo_podpisov'"
                                            v-if="aspect.properties['EH:stevilo_podpisov'] && checkIfVisibleOnGui('EH:stevilo_podpisov')"
                                        >

                                            <label :for="aspect.properties['EH:stevilo_podpisov'].name">{{aspect.properties['EH:stevilo_podpisov'].title}}<span
                                                v-if="editMode === false && (aspect.properties['EH:stevilo_podpisov'] && markedFieldsAddMode.includes(aspect.properties['EH:stevilo_podpisov'].name))">**</span><small
                                                class="text-black-50">(typ:
                                                {{aspect.properties['EH:stevilo_podpisov'] && aspect.properties['EH:stevilo_podpisov'].dataType}}, id: <i
                                                    class="fa fa-info"
                                                    :title="aspect.properties['EH:stevilo_podpisov'].name"></i>)</small></label>


                                            <input v-if="aspect.properties['EH:stevilo_podpisov'] && aspect.properties['EH:stevilo_podpisov'].dataType === 'd:long' || aspect.properties['EH:stevilo_podpisov'] && aspect.properties['EH:stevilo_podpisov'].dataType === 'd:int'"
                                                   type="number"
                                                   class="form-control"
                                                   :id="aspect.properties['EH:stevilo_podpisov'].name"
                                                   v-model="nodeData.properties[aspect.properties['EH:stevilo_podpisov'].name]"
                                                   :disabled="editMode === true && disabledFieldsEditMode.includes(aspect.properties['EH:stevilo_podpisov'].name)"
                                            >

                                        </div>

                                        E-podpisi ({{podpisi.length}})

                                        <div v-if="podpisi.length === 0" class="py-2">
                                            <em><i class="fa fa-exclamation-triangle"></i> Ni dodanih podpisov.</em>
                                        </div>

                                        <div class="table-responsive" v-if="podpisi.length > 0">
                                            <table class="table">
                                                <thead>
                                                <tr>
                                                    <th>polje</th>
                                                    <th v-for="(podpis,idx) in podpisi">vrednost za #{{idx+1}}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(property,_index,idx) in aspect.properties" v-if="property.name !== 'EH:stevilo_podpisov'">
                                                    <td>{{property.title}}</td>
                                                    <td v-for="(podpis) in podpisi">

                                                        {{podpis[property.name]}}

                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>akcije</td>
                                                    <td v-for="(podpis,_idx) in podpisi">
                                                        <a class="btn btn-sm btn-block text-white btn-danger" @click="() => { removeEsignature(_idx)}"><i class="fa fa-trash"></i> Odstrani</a>
                                                        <a class="btn btn-sm btn-block text-white btn-info" @click="() => { editEsignature(_idx)}"><i class="fa fa-edit"></i> Uredi</a>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>


                                        <div v-for="(property,_index) in aspect.properties"
                                             :class="property.dataType === 'd:boolean' ? 'form-check' : 'form-group'"
                                             v-if="property.name !== 'EH:stevilo_podpisov' && !eSignatureDataReadyForPost"
                                             :key="'property_' + _index">


                                            <!--                                                                                         {{property}}-->

                                            <input v-if="property.dataType === 'd:boolean'" type="checkbox"
                                                   class="form-check-input"
                                                   :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)"
                                            >

                                            <label :for="property.name">{{property.title}}<span
                                                v-if="editMode === false && markedFieldsAddMode.includes(property.name)">**</span><small
                                                class="text-black-50">(typ:
                                                {{property.dataType}}, id: <i class="fa fa-info" :title="property.name"></i>)</small></label>


                                            <input v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name !== 'EH:klasifikacijska_oznaka_razreda' && property.name !== 'EH:povezave_na_vodilne_dokumente' && (!property.name.includes('datum') && !property.name.includes('cas') && !property.name.includes('velja'))"
                                                   type="text" class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)"

                                            >

                                            <!-- klasifikacijska oznaka razreda-->
                                            <input v-if="property.dataType === 'd:text' && property.name === 'EH:klasifikacijska_oznaka_razreda'"
                                                   type="text" class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)"
                                                   @input="allowOnlyNumbers(property.name)"

                                            />

                                            <!-- povezave na vodilni dokument-->
                                            <vue-tags-input v-if="property.dataType === 'd:text' && property.name === 'EH:povezave_na_vodilne_dokumente'"
                                                            :id="property.name"
                                                            v-model="linksToLeadingDocumentTag"
                                                            :tags="linksToLeadingDocumentTags"
                                                            placeholder="vpiši ID gradiva in pritisni Enter"
                                                            style="max-width: initial"
                                                            @tags-changed="newTags => {linksToLeadingDocumentTags = newTags; onLinksToLeadingDocumentTagsChanged(newTags)}"
                                            />


                                            <input v-if="property.dataType === 'd:long' || property.dataType === 'd:int'"
                                                   type="number"
                                                   class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)">


                                            <div v-if="property.dataType == 'd:datetime' || ((property.dataType === 'd:text' || property.dataType === 'd:mltext') && (property.name.includes('datum') || property.name.includes('cas') || property.name.includes('velja')))">
                                                <div v-if="editMode === true && checkIfReadonly(property.name)">
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        :id="property.name"
                                                        :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).format('DD. MM. YYYY HH:mm:ss') : ''"
                                                        disabled
                                                    />
                                                </div>
                                                <div v-else>
                                                    <VueCtkDateTimePicker
                                                        :id="property.name"
                                                        :noLabel="true"
                                                        @input="selectDate"
                                                        format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                        formatted="DD.MM.YYYY, HH:mm:ss"
                                                        v-model="nodeData.properties[property.name]"
                                                        locale="sl"
                                                        :button-now-translation="$t('text.globals.now')"
                                                    />
                                                </div>
                                            </div>


                                            <div v-if="property.dataType == 'd:date'">
                                                <div v-if="editMode === true && checkIfReadonly(property.name)">
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        :noLabel="true"
                                                        :id="property.name"
                                                        :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).format('DD. MM. YYYY') : ''"
                                                        disabled

                                                    />
                                                </div>
                                                <div v-else>
                                                    <VueCtkDateTimePicker
                                                        :id="property.name"
                                                        :noLabel="true"
                                                        @input="selectDate"
                                                        format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                        formatted="DD.MM.YYYY"
                                                        :onlyDate="true"
                                                        v-model="nodeData.properties[property.name]"
                                                        locale="sl"
                                                        :button-now-translation="$t('text.globals.now')"
                                                    />
                                                </div>
                                            </div>



                                            <!--                                            <small class="text-danger"-->
                                            <!--                                                   v-if="$v.nodeData.properties[property.name] && $v.nodeData.properties[property.name].$error">-->
                                            <!--                                                <span v-if="$v.nodeData.properties[property.name].hasOwnProperty('required') && !$v.nodeData.properties[property.name].required">Polje ne sme biti prazno.</span>-->
                                            <!--                                                <span v-if="$v.nodeData.properties[property.name].hasOwnProperty('numeric') && !$v.nodeData.properties[property.name].numeric">Vrednost mora biti številka.</span>-->
                                            <!--                                            </small>-->

                                        </div>

                                        <div class="mt-3">
                                            <a class="btn btn-primary text-white" v-if="!eSignatureEditMode" @click="addEsignature()"><i class="fa fa-plus"></i> Dodaj e-podpis</a>
                                            <a class="btn btn-primary text-white" v-if="eSignatureEditMode" @click="updateEsignature()"><i class="fa fa-save"></i> Shrani spremembe v e-podpisu</a>
                                            <a class="btn btn-secondary text-white" v-if="eSignatureEditMode" @click="cancelEditingEsignature()">Prekliči urejanje e-podpisa</a>
                                            <!--  <a class="btn btn-link" @click="prepareEsignatureDataForPost()">Prepare data for post</a>-->
                                        </div>

                                    </div>

                                    <hr/>

                                </div>

                                <div class="p-4 bg-light">
                                    <h4>Uporabnik</h4>

                                    <div class="form-group">
                                        <label for="alfrescoUser">alfrescoUser</label>
                                        <input type="text" class="form-control" id="alfrescoUser"
                                               aria-describedby="alfrescoPassword"
                                               v-model="nodeData.alfrescoUser"

                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="alfrescoPassword">alfrescoPassword</label>
                                        <input type="text" class="form-control" id="alfrescoPassword"
                                               aria-describedby="alfrescoPassword"
                                               v-model="nodeData.alfrescoPassword"

                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="externalUserType">externalUserType</label>
                                        <v-select class="form-control" :options="['up_varnostne_sheme','up_s_certifikatom']" id="externalUserType"
                                                  v-model="nodeData.externalUserType">
                                            <span slot="no-options">Ni zadetkov.</span>
                                        </v-select>
                                    </div>

                                    <div class="form-group">
                                        <label for="externalUserId">externalUserId</label>
                                        <input type="text" class="form-control" id="externalUserId"
                                               aria-describedby="externalUserId"
                                               v-model="nodeData.externalUserId"

                                        />
                                    </div>

                                    <hr/>

                                    <div class="form-group">
                                        <label for="externalUserCertId">externalUserCertId</label>
                                        <input type="text" class="form-control" id="externalUserCertId"
                                               aria-describedby="externalUserCertId"
                                               v-model="nodeData.externalUserCertId"

                                        />
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-md-12 mt-3">

                                        <button class="btn btn-secondary"
                                                @click="$router.go(-1)">
                                            Opusti spremembe
                                        </button>

                                        <b-button id="uploadNewFileVersionButton1" class="float-right mr-0"
                                                  variant="primary" @click="save"><i
                                                class="fas fa-save"></i>
                                                Zajem EVIP
                                        </b-button>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import SidebarNavigation from '../components/SidebarNavigation';
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import {required, minLength, between, email, numeric} from 'vuelidate/lib/validators'
    import pdf from 'vue-pdf'
    import VueTagsInput from '@johmun/vue-tags-input';


    export default {
        name: 'DocumentDetailsEdit',
        components: {
            SidebarNavigation,
            Loading,
            vSelect,
            pdf,
            VueTagsInput
        },

        data() {
            return {
                fileId: this.$route.params.id,

                componentTag: '',
                componentTags: [],
                linksToLeadingDocumentTag: '',
                linksToLeadingDocumentTags: [],

                allMetadataOptions: this.$store.getters.getAllMetadataOptions,

                nodeData: {
                    "isFile": true,
                    "createdByUser": {
                        "id": "",
                        "displayName": ""
                    },
                    "modifiedAt": "",
                    "nodeType": "cm:content",
                    "content": {
                        "mimeType": "",
                        "mimeTypeName": "",
                        "sizeInBytes": 0,
                        "encoding": "UTF-8"
                    },
                    "parentId": "",
                    "aspectNames": [],
                    "createdAt": "",
                    "isFolder": false,
                    modifiedByUser: {
                        "id": "",
                        displayName: ""
                    },
                    "name": "",
                    "id": "",
                    "properties": {},
                    types: []
                },
                isLoading: false,
                isLoadingPreview: true,
                initialDocumentStatus: null,
                alfrescoDictionary: null,
                eHrambaAspectsDictionary: null,

                disabledFieldsEditMode: [
                    /*
                    'EH:status_pretvorbe_v_obliko_za_dolgorocno_hrambo',
                    //'EH:rok_hrambe',
                    'EH:datum_zacetka_teka_roka_hrambe',
                    'EH:oblika_gradiva_po_PETZ',
                    'EH:datum_zadnje_spremembe_statusa_gradiva',
                    'EH:mesto_hrambe',
                    'EH:status_pretvorbe_v_obliko_za_dolgotrajno_hrambo',
                    'EH:klasifikacijska_oznaka_razreda',
                    'EH:ID_zadeve',
                    'EH:oznaka_vpisnika',
                    'EH:oznaka_povezanega_sistema',
                    'EH:opravilna_stevilka_zadeve',
                    'EH:sodisce',
                    'EH:trajanje_roka_hrambe',
                    'EH:tip_gradiva',
                    'EH:povezave_na_vodilne_dokumente',
                    'EH:komponenta_povezave_na_dokumente'
                    */
                ],

                markedFieldsAddMode: [
                    'EH:rok_hrambe',
                    'EH:datum_zacetka_teka_roka_hrambe',
                    'EH:oblika_gradiva_po_PETZ',
                    'EH:datum_zadnje_spremembe_statusa_gradiva',
                    'EH:mesto_hrambe',
                    'EH:format_gradiva_preverjen',
                    'EH:format_datum_preverbe',
                    'EH:koncni_format',
                    'EH:format_ustrezen',
                    'EH:po_za_konverzijo',
                    'EH:izvorna_oblika',
                    'EH:trajanje_roka_hrambe'
                ],

                aspects: [
                    "EH:osnovni_podatki",
                    "EH:e_podpis",
                    "EH:podatki_o_fizicnem_gradivu",
                    "EH:dodatni_podatki",
                    "EH:klasifikacija",
                    "EH:hramba",
                    "EH:oznaka_zadeve",
                    "EH:premikanje_med_sistemi"
                ],
                editMode: false,
                eSignatureEditMode: false,
                eSignatureItemInEdit: null,
                eSignatureDataReadyForPost: false,
                podpisi: [],
                codeListProperties: []

            };
        },


        beforeCreate: function () {
            document.body.className = 'dashboard';
        },

        mounted() {

            // this.$store.dispatch("retrieveAlfrescoDictionary").then(() => {
            //
            //
            //     this.alfrescoDictionary = this.$store.getters.getAlfrescoDictionary;
            //     console.log("alfresco dictionary: ", this.alfrescoDictionary);
            //
            //     this.eHrambaAspectsDictionary = this.$store.getters.geteHrambaAlfrescoDictionary;
            //     console.log("aspectsDictionary", this.eHrambaAspectsDictionary);
            //
            //
            //     if (this.$store.getters.getAllMetadataOptions.length === 0) {
            //         this.$store.dispatch('retrieveAllMetadataOptions').then(() => {
            //             this.allMetadataOptions = this.$store.getters.getAllMetadataOptions;
            //         })
            //     }
            //     console.log("allMetadataOptions", this.allMetadataOptions);
            //     this.getNode(this.fileId);
            //
            //
            //
            // });


            const _this = this;

            let p1 = _this.$store.dispatch("retrieveAlfrescoDictionary");
            let p2 = _this.$store.dispatch("retrieveCodeListProperties");
            let p3 = _this.$store.dispatch("retrieveAllMetadataOptions");


            Promise.all([p1, p2, p3]).then((values) => {
                this.alfrescoDictionary = this.$store.getters.getAlfrescoDictionary;
                console.log("alfresco dictionary: ", this.alfrescoDictionary);

                this.eHrambaAspectsDictionary = this.$store.getters.geteHrambaAlfrescoDictionary;
                console.log("aspectsDictionary", this.eHrambaAspectsDictionary);

                this.codeListProperties = this.$store.getters.getCodeListProperties;
                console.log("codeListProperties", this.codeListProperties);

                this.allMetadataOptions = this.$store.getters.getAllMetadataOptions;
                console.log("allMetadataOptions", this.allMetadataOptions);

                this.getNode(this.fileId);
                this.editMode = true;
            });


        },

        computed: {

        },
        methods: {

            async getNode(nodeId) {
                const _this = this;

                await axios.get(config.alfrescoCoreApi + 'nodes/' + nodeId)
                    .then((res) => {

                        console.log(res);
                        _this.nodeData = res.data.entry;


                        _this.isLoading = false;
                        console.log("nodeData: ", _this.nodeData);
                        this.initialDocumentStatus = this.nodeData.properties["EH:status_gradiva"];
                        if( _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'pdf' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'image' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'audio' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'video') {
                            _this.isLoading = false;
                        } else {
                            _this.isLoading = false;
                            _this.isLoadingPreview = true;
                        }


                        //_this.componentTags = _this.nodeData.properties['EH:komponenta_povezave_na_dokumente'];
                        _.map(_this.nodeData.properties['EH:komponenta_povezave_na_dokumente'], function(val){
                            _this.componentTags.push({
                                text: val
                            });
                        });

                        // handle saved esginatures
                        if(_this.nodeData.properties['EH:gradivo_e_podpisano']) {
                            _.map(_this.eHrambaAspectsDictionary, function(v, k){
                                if(v.name === 'EH:e_podpis') {
                                    _.map(v.properties, function(_v, _k, idx){
                                        _.each(_this.nodeData.properties[_k], function(_arr_val, _arr_idx){
                                            _this.podpisi[_arr_idx] = _.assign(_this.podpisi[_arr_idx], {[_k]: _arr_val});
                                            _this.nodeData.properties[_k] = "";
                                        });
                                    });
                                }
                            });
                            _this.eSignatureDataReadyForPost = false;
                        }

                    })
                    .catch((error) => {
                        console.error(error);

                        _this.isLoading = false;
                    });


            },

            selectDate(selectedDate) {
                const _this = this;
                console.log("selectedDate", selectedDate);
                _this.$forceUpdate(); // workaround to force update VueCtkDateTimePicker component
            },

            save() {
                const _this = this;
                _this.isLoading = true;

                _this.prepareEsignatureDataForPost();

                let types = _.filter(_this.$store.getters.getAlfrescoDictionary, function (v, k) {
                    if (_this.nodeData.aspectNames.indexOf(v.name) > -1 && v.name.substring(0, 4) !== 'rma:') {
                        return true
                    } else {
                        return false
                    }
                });

                let data = {
                    nodeId: _this.$route.params.id,
                    aspects: _this.aspects,
                    properties: _this.nodeData.properties,
                    types: types,
                    externalUserType: _this.nodeData.externalUserType,
                    externalUserId: _this.nodeData.externalUserId,
                    externalUserCertId: _this.nodeData.externalUserCertId,
                    alfrescoUser: _this.nodeData.alfrescoUser,
                    alfrescoPassword: _this.nodeData.alfrescoPassword
                };

                // filter data - only specific fields can be updated
                let propertiesForUpdate = [];
                _.forOwn(data.properties, function (v, k) {
                    if (k.substring(0, 3) === 'EH:') {
                            propertiesForUpdate.push(k);
                    }
                });
                propertiesForUpdate.push('cm:description', 'cm:author', 'cm:title');
                data.properties = _.pick(data.properties, propertiesForUpdate);

                // covert long and int string to int + remove null items
                _.each(data.properties, function (val, key) {
                    _.forOwn(data.types, function(_val){
                        if(_val.properties[key] && (_val.properties[key].dataType === 'd:long' || _val.properties[key].dataType === 'd:int')) {
                            if(val !== null && val !== '' || val.length > 0) {

                                if(Array.isArray(val)) {
                                    data.properties[key] = _.map(val, function (v) {
                                        return parseInt(v);
                                    });
                                } else {
                                    data.properties[key] = parseInt(val);
                                }
                            } else if(val == '') {
                                data.properties[key] = null;
                            }
                        } else if(_val.properties[key] && _val.properties[key].dataType === 'd:datetime' && _val.properties[key].dataType === 'd:date') {
                            if(val !== null && val !== '' || val.length > 0) {

                                if(Array.isArray(val)) {
                                    data.properties[key] = _.map(val, function (v) {
                                        return _this.moment(v).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
                                    });
                                } else {
                                    data.properties[key] = _this.moment(val).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
                                }
                            } else if(val == '') {
                                data.properties[key] = null;
                            }
                        }
                    });


                    // remove all items where value is null on empty string
                    if(data.properties[key] === null || data.properties[key] === "" || data.properties[key].length === 0) {
                        delete data.properties[key]
                    }
                });


                if(_this.podpisi.length > 0) {
                    data.properties['EH:stevilo_podpisov'] = _this.podpisi.length;
                }

                delete data.types;



                console.log("DATA!:", data);

                axios.post(config.demoVpisnik + 'receiveFromEvip', data)
                    .then((res) => {

                        console.log("SAVE ---> ", res.data);
                        //_this.getNode(_this.nodeData.id);
                        // _this.$router.replace({name: 'DocumentDetails', params: {id: _this.nodeData.id}});


                        this.isLoading = false;
                        Vue.$toast.open({
                            message: 'Gradivo uspešno zajeto iz EVIP!',
                            type: 'success',
                            position: 'top-right'
                        });

                        setTimeout(function () {
                            _this.$router.go(-1);
                        },500);


                    })
                    .catch((error) => {
                        console.error(error);
                        this.isLoading = false;

                        Vue.$toast.open({
                            message: 'Napaka pri nalaganju na strežnik.',
                            type: 'error',
                            position: 'top-right'
                        });
                    });


            },

            checkIfCodeList(propertyName) {
                const _this = this;
                let isCodeList = false;

                _.each(_this.allMetadataOptions, function (val, key) {
                    let property = val.property;

                    if(propertyName === property) {
                        isCodeList = true;
                        return false;
                    }
                });

                return isCodeList;

            },

            getCodeListOptions(propertyName) {
                const _this = this;
                let options = [];

                _.each(_this.allMetadataOptions, function (val, key) {
                    let property = val.property;

                    if(propertyName === property) {
                        options = val.body;
                        return false;
                    }
                });

                return options
            },

            loadSampleNodeData(oznakaVpisnika) {
                const _this = this;

                _this.nodeData.properties = {};

                if(oznakaVpisnika === 'EVIP') {
                    // _this.nodeData.properties["EH:ID_gradiva"] = "123";
                    // _this.nodeData.properties["EH:fizicno_gradivo"] = false;
                    // _this.nodeData.properties["EH:datum_gradiva"] = "2019-01-01T10:00:00.000Z";
                    // _this.nodeData.properties["EH:status_gradiva"] = 1;
                    // _this.nodeData.properties["EH:stopnja_zaupnosti"] = 1;
                    // _this.nodeData.properties["EH:gradivo_e_podpisano"] = false;
                    // _this.nodeData.properties["EH:oznaka_povezanega_sistema"] = "EVIP";
                    // _this.nodeData.properties["EH:sodisce"] = "S23";
                    // _this.nodeData.properties["EH:izvor_gradiva"] = 4;

                } else if(oznakaVpisnika === 'SU') {
                    _this.nodeData.properties["EH:vrsta_gradiva"] = 1;
                    _this.nodeData.properties["EH:tip_gradiva"] = 1;
                    _this.nodeData.properties["cm:description"] = "To je kratek opis vsebine";
                    _this.nodeData.properties["EH:stopnja_zaupnosti"] = 3;
                    _this.nodeData.properties["EH:lokacija_hrambe"] = "";
                    _this.nodeData.properties["EH:datum_gradiva"] = "2019-01-01T10:00:00.000Z";
                    _this.nodeData.properties["EH:status_gradiva"] = 1;
                    _this.nodeData.properties["EH:ID_zadeve"] = "123";
                    _this.nodeData.properties["EH:ID_gradiva"] = "123456";
                    _this.nodeData.properties["EH:gradivo_e_podpisano"] = false;
                    _this.nodeData.properties["EH:oznaka_povezanega_sistema"] = "SUVP";
                    _this.nodeData.properties["EH:opravilna_stevilka_zadeve"] = "SU 1/2019";
                    _this.nodeData.properties["EH:oznaka_vpisnika"] = "741";
                    _this.nodeData.properties["EH:sodisce"] = "S23";
                    _this.nodeData.properties["EH:oznaka_priloge_v_popisu_spisa"] = "A1";
                    _this.nodeData.properties["EH:posiljatelj_vloznik"] = "Rettro d.o.o., Šlandrova 4b, 1000 Ljubljana";
                    _this.nodeData.properties["EH:izvor_gradiva"] = 4;
                }
            },

            addEsignature() {
                const _this = this;

                _this.initEsignatureData();
                let podpis = {};

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k){
                            if(_k !== 'EH:stevilo_podpisov') {
                                podpis[_k] = _this.nodeData.properties[_k];
                            }
                        });
                    }
                });

                _this.podpisi.push(podpis);

                _this.cancelEditingEsignature();
            },

            removeEsignature(idx) {
                const _this = this;

                _this.podpisi.splice(idx,1);
            },

            editEsignature(idx) {
                const _this = this

                _this.initEsignatureData();
                _this.cancelEditingEsignature();

                let signature = _this.podpisi[idx];
                _this.eSignatureItemInEdit = idx;
                _this.eSignatureEditMode = true;

                _.forOwn(_this.podpisi[idx], function (v, k) {
                    _this.nodeData.properties[k] = v;
                });

                console.log("signature", signature);
            },

            cancelEditingEsignature() {
                const _this = this;

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k){
                            if(_k !== 'EH:stevilo_podpisov') {
                                _this.nodeData.properties[_k] = '';
                            }
                        });
                    }
                });

                _this.eSignatureEditMode = false;
                _this.eSignatureItemInEdit = null;
            },

            updateEsignature() {
                const _this = this;

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k){
                            _this.podpisi[_this.eSignatureItemInEdit][_k] = _this.nodeData.properties[_k];
                        });
                    }
                });

                _this.cancelEditingEsignature();
            },

            initEsignatureData() {
                const _this = this;

                _this.eSignatureDataReadyForPost = false;

                // TODO: should we reset field here?
                // _.map(_this.eHrambaAspectsDictionary, function(v, k){
                //     if(v.name === 'EH:e_podpis') {
                //         _.map(v.properties, function(_v, _k){
                //             if(_k !== 'EH:stevilo_podpisov') {
                //                 console.log(_v);
                //                 // podpis[_k] = _this.nodeData.properties[_k];
                //             }
                //         });
                //     }
                // });

            },

            prepareEsignatureDataForPost() {
                const _this = this;

                _this.eSignatureDataReadyForPost = true;
                _this.eSignatureEditMode = false;
                _this.eSignatureItemInEdit = null;

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k, idx){
                            if(_k !== 'EH:stevilo_podpisov') {
                                _this.nodeData.properties[_k] = [];
                            }
                        });
                    }
                });


                _.map(_this.podpisi, function(v, k){
                    _.forOwn(v, function (_v, _k) {
                        console.log("_k", _k);
                        console.log("_v", _v);

                        _this.nodeData.properties[_k].push(_v ? _v : '');
                    });
                });

                _this.$forceUpdate();

                console.log("_this.nodeData", _this.nodeData);
            },

            checkIfReadonly(name) {
                const _this = this;
                let readOnly = false;

                _.map(_this.codeListProperties, function (item) {
                    _.filter(item.properties, function (innerItem) {
                        if(innerItem.name === name) {
                            readOnly = innerItem.readOnly
                        }
                    });
                });


                return readOnly;
            },

            checkIfVisibleOnGui(name) {
                const _this = this;
                let visibleOnGui = false;

                _.map(_this.codeListProperties, function (item) {
                    _.filter(item.properties, function (innerItem) {
                        if(innerItem.name === name) {
                            visibleOnGui = innerItem.showOnGui
                        }
                    });
                });

                return visibleOnGui;
            }

        },

        onComponentTagsChanged(newTags) {
            const _this = this;

            console.log("newTags", newTags);


            let tags = [];
            _.map(_this.componentTags, function (val) {
                console.log(val)
                tags.push(val.text.trim());
            });
            _this.nodeData.properties['EH:komponenta_povezave_na_dokumente'] = tags;

        },

        onLinksToLeadingDocumentTagsChanged(newTags) {
            const _this = this;

            console.log("newTags", newTags);


            let tags = [];
            _.map(_this.linksToLeadingDocumentTags, function (val) {
                console.log(val)
                tags.push(val.text.trim());
            });
            _this.nodeData.properties['EH:povezave_na_vodilne_dokumente'] = tags;

        },

        cancel() {
            console.log("TODO - CANCEL");
            window.history.go(-1);
        },


    };
</script>



// WEBPACK FOOTER //
// src/pages/DocumentEvipTestClient.vue